export default "__VITE_ASSET__6qECqMgU__"